import { render } from "./DateTypeComponent.vue?vue&type=template&id=24da3a22&scoped=true"
import script from "./DateTypeComponent.vue?vue&type=script&lang=js"
export * from "./DateTypeComponent.vue?vue&type=script&lang=js"

import "./DateTypeComponent.vue?vue&type=style&index=0&id=24da3a22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24da3a22"]])

export default __exports__